<template>
  <AppLayout>
    <div class="container mt-4">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h3>Zestawienie salek - Tydzień {{ selectedWeek }}, {{ selectedYear }}</h3>
        <div>
          <button class="btn btn-sm btn-outline-secondary me-2 mb-2" @click="changeWeek(-1)">← Poprzedni</button>
          <button class="btn btn-sm btn-outline-secondary mb-2" @click="changeWeek(1)">Następny →</button>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-auto d-flex align-items-center me-3">
          <label class="me-2">Tydzień:</label>
          <select v-model="selectedWeek" class="form-select form-sm" style="width: 140px;" @change="loadSelectedWeek">
            <option v-for="week in 52" :key="week" :value="week">Tydzień {{ week }}</option>
          </select>
        </div>

        <div class="col-auto d-flex align-items-center">
          <label class="me-2">Rok:</label>
          <select v-model="selectedYear" class="form-select form-sm" style="width: 140px;" @change="loadSelectedWeek">
            <option v-for="year in yearRange" :key="year" :value="year">{{ year }}</option>
          </select>
        </div>
      </div>

      <div class="rooms-container d-flex overflow-auto" style="gap: 1rem; white-space: nowrap; padding-bottom: 0.5rem;">
        <div class="room-card position-relative" v-for="room in visibleRooms" :key="room.id">
          <button type="button" class="btn btn-sm-oko btn-danger position-absolute top-0 end-0 m-1" title="Ukryj"
                  @click="hideRoom(room.id)" @mouseenter="hoverStates[room.id] = true"
                  @mouseleave="hoverStates[room.id] = false"><i
              :class="hoverStates[room.id] ? 'bi bi-eye-slash' : 'bi bi-eye'"></i></button>
          <div class="p-2 rounded shadow-sm" :style="{ backgroundColor: room.color }">
            <center><label :style="{ color: room.textColor , fontSize : '18px' }"><strong>{{
                room.name
              }}</strong><br>{{ room.description }}</label></center>
            <table class="table table-bordered text-center table-hover">
              <thead>
              <tr>
                <th>Godzina</th>
                <th v-for="day in weekDays" :key="day.date">
                  {{ formatDay(day.date) }}.{{ formatMonthYear(day.date) }}<br>
                  {{ day.name }}
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="hour in workHours" :key="hour">
                <td>{{ hour }}</td>
                <td v-for="day in weekDays" :key="day.date.toISOString()">
                  <div v-if="hasPermission('canAddConferenceRoom')" class="position-relative reservation-cell"
                       @click="openModal(day.date, hour, room)">
                    <span v-if="!hasReservation(room.id, day.date, hour)" class="empty-slot"></span>
                    <span v-else class="text-truncate">{{
                        truncateText(getReservation(room.id, day.date, hour).name, 15)
                      }}</span>
                    <i v-if="hasReservation(room.id, day.date, hour) && getReservation(room.id, day.date, hour).name === getShortName(userName)"
                       class="bi bi-trash text-danger delete-btn" title="Usuń"
                       @click.stop="deleteReservationSingle(room.id, day.date, hour)"></i>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div v-if="isModalOpen" class="modal fade show" tabindex="-1" style="display: block;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Rezerwacja sali</h5>
              <button type="button" class="btn-close" @click="closeModal"></button>
            </div>
            <div class="modal-body">
              <p><strong>Dzień rezerwacji:</strong> {{ formatDay(selectedDay) }}.{{ formatMonthYear(selectedDay) }}</p>
              <p><strong>Godzina:</strong> {{ reservation.startHour }}</p>
              <div class="mb-3">
                <label for="name" class="form-label">Imię i Nazwisko</label>
                <input v-model="reservation.name" type="text" class="form-control" id="name"
                       placeholder="Imię i nazwisko">
              </div>
              <div class="mb-3">
                <label for="reservationType" class="form-label">Typ rezerwacji</label>
                <select v-model="reservation.type" class="form-select" id="reservationType">
                  <option value="single">Wybrana godzina</option>
                  <option value="multiple">Do godziny</option>
                </select>
              </div>
              <div v-if="reservation.type === 'multiple'" class="mb-3">
                <label for="endHour" class="form-label">Do godziny</label>
                <select v-model="reservation.endHour" class="form-select" id="endHour">
                  <option v-for="(hour, index) in workHours" :key="index" :value="hour">{{ hour }}</option>
                </select>
              </div>
              <div class="mb-3">
                <div class="checkbox-success custom-control custom-checkbox d-inline-block">
                  <input id="isRecurring" type="checkbox" class="custom-control-input" v-model="isRecurring"
                         @change="handleRecurringChange">
                  <label for="isRecurring" class="custom-control-label h6">Powtarzaj rezerwacje co tydzień</label>
                </div>
              </div>
              <div v-if="isRecurring" class="mb-3">
                <label for="recurrenceEndMonth" class="form-label">Powtarzaj do końca miesiąca:</label>
                <select v-model="recurrenceEndMonth" class="form-select" id="recurrenceEndMonth">
                  <option v-for="month in monthOptions" :value="month.value" :key="month.value">{{
                      month.text
                    }}
                  </option>
                </select>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeModal">Zamknij</button>
              <button v-if="hasPermission('canAddConferenceRoom')" type="button" class="btn btn-primary"
                      @click="saveReservation">Zapisz
              </button>
              <button type="button" class="btn btn-outline-primary ms-2" @click="downloadICS">Pobierz zaproszenie do
                kalendarza
              </button>
            </div>
            <div v-if="reservationHistory.length > 0" class="modal-body">
              <div class="mt-3">
                <h6>Historia zmian:</h6>
                <ul class="list-group">
                  <li v-for="item in reservationHistory" :key="item.id" class="list-group-item"
                      v-html="formatChangeLog(item)"></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import Swal from 'sweetalert2';

const {hasPermission} = usePermission();

async function askConflictChoice(conflicts) {
  const {value: choice} = await Swal.fire({
    title: 'Wykryto konflikty',
    html: conflicts.map(c => `${c.usernames.join(', ')} 📅 ${c.date}  ⏰ ${c.hours.join(', ')}`).join('<br>'),

    input: 'select',
    inputOptions: {
      '1': 'Nadpisz wszystkie konflikty',
      '2': 'Pomiń dni z konfliktami',
      '3': 'Anuluj operację'
    },
    inputPlaceholder: 'Wybierz opcję',
    showCancelButton: true,
    inputAttributes: {class: 'selectKolor'},
  });
  return choice;
}

export default {
  components: {AppLayout, hasPermission},
  props: {
    rooms: Array,
    days: Array,
    year: Number,
    week: Number,
    userName: String,
    reservations: Object,
    locked: Boolean,
    roomsDepartmentMap: Object,
  },
  data() {
    const now = new Date();
    const currentYear = now.getFullYear();
    return {
      hasPermission,
      isLoading: false,
      reservationHistory: [],
      selectedYear: currentYear,
      selectedWeek: this.getWeekNumber(now),
      yearRange: Array.from({length: 10}, (_, i) => currentYear - 1 + i),
      weekDays: [],
      workHours: this.generateHourLabels(),
      isModalOpen: false,
      hover: false,
      hoverStates: {},
      canEditReservation: true,
      reservation: {
        name: '',
        type: 'single',
        startHour: '',
        endHour: ''
      },
      selectedDay: null,
      hiddenRooms: [],
      selectedRoom: this.rooms.length > 0 ? this.rooms[0] : null,
      localReservations: {},
      checkInterval: null,
      isRecurring: false,
      recurrenceEndMonth: null,
      monthOptions: this.getRemainingMonths()
    };
  },
  computed: {
    visibleRooms() {
      return this.rooms.filter(room => room?.id && !this.hiddenRooms.includes(room.id));
    }
  },
  mounted() {
    this.localReservations = JSON.parse(JSON.stringify(this.reservations || {})); 
    this.loadSelectedWeek();
    this.reservation.name = this.userName;
    this.startAutoUpdate();
  },
  beforeDestroy() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
  },
  methods: {

    async deleteRecurringReservations() {
      const startDate = new Date(this.selectedDay);
      let currentDate = new Date(startDate);
      let endDate;

      if (this.recurrenceEndMonth) {
        let [nyear, nmonth] = this.recurrenceEndMonth.split('-').map(Number);
        endDate = new Date(nyear, nmonth, 0);
      } else {
        endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
      }

      const datesToDelete = [];
      while (currentDate <= endDate) {
        datesToDelete.push(this.formatDate(currentDate));
        currentDate.setDate(currentDate.getDate() + 7);
      }

      const confirm = await Swal.fire({
        title: "Potwierdzenie",
        html: `Czy na pewno chcesz <strong>usunąć rezerwacje</strong> dla wybranych dni tygodniowo do końca okresu?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Tak, usuń",
        cancelButtonText: "Anuluj"
      });
      if (!confirm.isConfirmed) return;
      for (const dateStr of datesToDelete) {
        const payload = {
          room_id: this.selectedRoom.id,
          date: dateStr,
          start_hour: this.formatHour(this.reservation.startHour),
          end_hour: this.formatHour(this.reservation.type === 'single' ? this.reservation.startHour : this.reservation.endHour),
        };

        try {
          await axios.delete('/conferencerooms/reservation', {data: payload});

          const roomRes = this.localReservations?.[this.selectedRoom.id]?.[dateStr];
          if (roomRes && roomRes[payload.start_hour]) {
            this.$delete(this.localReservations[this.selectedRoom.id][dateStr], payload.start_hour);
          }
        } catch (err) {
          console.warn('Błąd przy usuwaniu:', dateStr, err);
        }
      }
      Toast.fire({icon: 'success', title: 'Usunięto cykliczne rezerwacje.'});
    },

    truncateText(text, maxLength) {
      if (!text) return '';
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    },
    getShortName(fullName) {
      if (!fullName) return '';
      const parts = fullName.trim().split(' ');
      if (parts.length < 2) return fullName;
      return `${parts[0][0]}. ${parts.slice(1).join(' ')}`;
    },
    async deleteReservationSingle(roomId, date, hour) {
      const payload = {
        room_id: roomId,
        date: this.formatDate(date),
        start_hour: this.formatHour(hour),
        end_hour: this.formatHour(hour),
      };

      try {
        await axios.delete('/conferencerooms/reservation', {data: payload});

        if (this.localReservations?.[roomId]?.[payload.date]?.[payload.start_hour]) {
          this.$delete(this.localReservations[roomId][payload.date], payload.start_hour);
        }

        Toast.fire({icon: 'success', title: 'Rezerwacja usunięta.'});

      } catch (error) {
        Toast.fire({icon: 'error', title: 'Błąd przy usuwaniu rezerwacji.'});
      }
    },
    getRemainingMonths() {
      let baseDate;

      try {
        const simple = new Date(this.selectedYear, 0, 1 + (this.selectedWeek - 1) * 7);
        const dow = simple.getDay();
        const ISOweekStart = new Date(simple);
        if (dow <= 4)
          ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
        else
          ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());

        baseDate = ISOweekStart;
      } catch (e) {
        baseDate = new Date();
      }

      const months = [];
      const currentMonth = baseDate.getMonth();
      const currentYear = baseDate.getFullYear();

      for (let i = currentMonth; i < 12; i++) {
        const date = new Date(currentYear, i);
        months.push({
          value: `${currentYear}-${(i + 1).toString().padStart(2, '0')}`,
          text: date.toLocaleString('pl-PL', {month: 'long', year: 'numeric'}),
        });
      }

      return months;
    },

    startAutoUpdate() {
      this.checkInterval = setInterval(() => {
        if (!this.isModalOpen) {
          this.loadSelectedWeek();
        }
      }, 5000);
    },

    stopAutoUpdate() {
      if (this.checkInterval) {
        clearInterval(this.checkInterval);
      }
    },


    generateICS() {
      const endHourValue = this.reservation.type === 'single'
          ? (() => {
            const [startH, startM] = this.reservation.startHour.split(':').map(Number);
            let endH = startH + 1;
            if (endH > 23) endH = 23;
            return `${endH.toString().padStart(2, '0')}:${startM.toString().padStart(2, '0')}`;
          })()
          : this.reservation.endHour;

      const dtStart = this.formatICalDateTime(this.selectedDay, this.reservation.startHour);
      const dtEnd = this.formatICalDateTime(this.selectedDay, endHourValue);

      const uid = Date.now() + '@yourapp.com';

      return `
BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//YourApp//ConferenceRoomBooking//PL
BEGIN:VEVENT
UID:${uid}
DTSTAMP:${this.formatICalDateTime(new Date(), '00:00')}
DTSTART:${dtStart}
DTEND:${dtEnd}
SUMMARY:Spotkanie w: ${this.selectedRoom.name}
DESCRIPTION:${this.reservation.name}
LOCATION:${this.selectedRoom.name}
END:VEVENT
END:VCALENDAR
`.trim();
    },

    formatICalDateTime(date, hour) {
      const [h, m] = hour.split(':');
      const d = new Date(date);
      d.setHours(+h, +m, 0, 0);
      const yyyy = d.getUTCFullYear();
      const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
      const dd = String(d.getUTCDate()).padStart(2, '0');
      const hh = String(d.getUTCHours()).padStart(2, '0');
      const mi = String(d.getUTCMinutes()).padStart(2, '0');
      const ss = '00';
      return `${yyyy}${mm}${dd}T${hh}${mi}${ss}Z`;
    },

    downloadICS() {
      const icsContent = this.generateICS();
      const blob = new Blob([icsContent], {type: 'text/calendar;charset=utf-8'});
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Rezerwacja-${this.selectedRoom.name}-${this.formatDate(this.selectedDay)}.ics`;
      a.click();
      URL.revokeObjectURL(url);
    },

    hideRoom(roomId) {
      if (!this.hiddenRooms.includes(roomId)) {
        this.hiddenRooms.push(roomId);
      }
    },

    async loadReservationHistory(roomId, date, hour) {
      try {
        const response = await axios.get('/conferencerooms/reservation-history', {
          params: {
            room_id: roomId,
            date: this.formatDate(date),
            hour: this.formatHour(hour),
          }
        });
        this.reservationHistory = response.data.history;
      } catch (error) {
        this.reservationHistory = [];
      }
    },
    formatChangeLog(item) {
      const user = item.username;
      const oldData = JSON.parse(item.old_data || '{}');
      const newData = JSON.parse(item.new_data || '{}');
      const rhour = newData.hour || oldData.hour || '(brak godziny)';
      const hourWithoutSeconds = rhour ? rhour.slice(0, 5) : '(brak godziny)';

      const date = item.created_at ? item.created_at.split(' ')[0] : '';
      const time = item.created_at ? item.created_at.split(' ')[1] : '';

      if (Object.keys(newData).length === 0) {
        return `${date} ${time} : <strong>${user}</strong> - usunięto rezerwację na godzinę ${hourWithoutSeconds}`;
      }

      if (Object.keys(oldData).length === 0) {
        return `${date} ${time} : <strong>${user}</strong> - utworzono rezerwację: ${newData.username || '(brak nazwy)'} na godzinę ${hourWithoutSeconds}`;
      }

      let changes = [];
      for (const key in newData) {
        if (['updated_at', 'created_at', 'id'].includes(key)) continue;
        if (oldData[key] !== newData[key]) {
          changes.push(`${key} z "${oldData[key]}" na "${newData[key]}"`);
        }
      }

      if (changes.length === 0) {
        return `${date} ${time} : <strong>${user}</strong> - zmieniono dane, ale nie wykryto różnic`;
      }

      return `${date} ${time} : <strong>${user}</strong> - zmieniono rezerwację: ${changes.join(', ')} na godzinę ${hourWithoutSeconds}`;
    },

    async loadSelectedWeek() {
      this.isLoading = true;
      this.weekDays = this.generateWeekDays(this.selectedYear, this.selectedWeek);
      try {
        const response = await axios.get('/conferencerooms/reservations', {
          params: {
            year: this.selectedYear,
            week: this.selectedWeek,
          }
        });
        this.localReservations = response.data.reservations;
      } catch (error) {
        this.localReservations = {};
      } finally {
        this.isLoading = false;
      }
      this.isRecurring = false;
      this.recurrenceEndMonth = null;
      this.monthOptions = this.getRemainingMonths();
    },

    formatHour(hour) {
      const [h, m] = hour.split(':');
      return `${h.padStart(2, '0')}:${m.padStart(2, '0')}:00`;
    },

    hasReservation(roomId, date, hour) {
      const dayKey = this.formatDate(date);
      const formattedHour = this.formatHour(hour);
      return !!this.localReservations?.[roomId]?.[dayKey]?.[formattedHour];
    },

    getReservation(roomId, date, hour) {
      const dayKey = this.formatDate(date);
      const formattedHour = this.formatHour(hour);
      return this.localReservations?.[roomId]?.[dayKey]?.[formattedHour] || null;
    },

    changeWeek(offset) {
      let newWeek = this.selectedWeek + offset;
      if (newWeek < 1) {
        this.selectedYear--;
        this.selectedWeek = 52;
      } else if (newWeek > 52) {
        this.selectedYear++;
        this.selectedWeek = 1;
      } else {
        this.selectedWeek = newWeek;
      }
      this.loadSelectedWeek();

    },

    getWeekNumber(date) {
      const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
      const pastDaysOfYear = (date - firstDayOfYear) / 86400000;
      return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
    },

    generateWeekDays(year, weekNumber) {
      const simpleDate = new Date(year, 0, 4);
      const dayOfWeek = simpleDate.getDay() || 7;
      const monday = new Date(simpleDate);
      monday.setDate(simpleDate.getDate() - dayOfWeek + 1 + (weekNumber - 1) * 7);

      const days = [];
      const dayNames = ["Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek"];
      for (let i = 0; i < 5; i++) {
        const day = new Date(monday);
        day.setDate(monday.getDate() + i);
        days.push({date: new Date(day), name: dayNames[i]});
      }
      return days;
    },

    generateHourLabels() {
      const hours = [];
      for (let h = 6; h <= 15; h++) {
        hours.push(`${h.toString().padStart(2, '0')}:00`);
        if (h !== 15) {
          hours.push(`${h.toString().padStart(2, '0')}:30`);
        }
      }
      return hours;
    },

    formatDay(date) {
      return ("0" + date.getDate()).slice(-2);
    },

    formatMonthYear(date) {
      return ("0" + (date.getMonth() + 1)).slice(-2) + "." + date.getFullYear();
    },

    formatDate(date) {
      if (!date) return '';
      if (!(date instanceof Date)) date = new Date(date);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    async openModal(day, hour, room) {
      this.selectedDay = day;
      this.selectedRoom = room || (this.rooms.length > 0 ? this.rooms[0] : null);
      this.reservation.startHour = hour;
      this.reservation.endHour = hour;

      const allowedDepartments = this.roomsDepartmentMap?.[this.selectedRoom.id] || [];
      const userDepartmentId = this.$page.props.department_id;

      this.canEditReservation = allowedDepartments.length === 0 || allowedDepartments.includes(userDepartmentId);

      if (!this.canEditReservation) {
        Toast.fire({icon: 'error', title: 'Uwaga!', html: 'Nie masz uprawnień do edycji tej sali.',});
        return;
      }

      if (this.hasReservation(this.selectedRoom.id, day, hour)) {
        const existingReservation = this.getReservation(this.selectedRoom.id, day, hour);
        this.reservation.name = existingReservation.name || this.userName;
        this.reservation.type = 'single';
        this.reservation.endHour = hour;
        await this.loadReservationHistory(this.selectedRoom.id, day, hour);
      } else {
        this.reservation.name = this.userName;
        this.reservation.type = 'single';
        this.reservation.endHour = hour;
        //this.reservationHistory = [];
        await this.loadReservationHistory(this.selectedRoom.id, day, hour);
      }
      this.isModalOpen = true;
    },

    closeModal() {
      this.isModalOpen = false;
      this.reservation.name = this.userName;
      this.reservation.type = 'single';
      this.reservation.startHour = '';
      this.reservation.endHour = '';
    },

    async saveReservation() {
      try {
        if (!this.selectedRoom) {
          Toast.fire({icon: 'error', title: 'Uwaga!', html: 'Nie wybrano sali.'});
          return;
        }

        if (!this.canEditReservation) {
          Toast.fire({icon: 'error', title: 'Uwaga!', html: 'Nie masz uprawnień do edycji tej sali.'});
          return;
        }

        if (!this.reservation.name || this.reservation.name.trim() === '') {
          if (this.isRecurring) {
            await this.deleteRecurringReservations();
            this.closeModal();
            return;
          } else if (this.hasReservation(this.selectedRoom.id, this.selectedDay, this.reservation.startHour)) {
            await this.deleteReservation();
            this.closeModal();
            Toast.fire({icon: 'success', title: 'Usunięto rezerwację.'});
          } else {
            Toast.fire({icon: 'error', title: 'Błąd!', html: 'Imię i nazwisko jest wymagane.'});
          }
          return;
        }

        const payload = {
          room_id: this.selectedRoom.id,
          username: this.reservation.name,
          date: this.formatDate(this.selectedDay),
          start_hour: this.formatHour(this.reservation.startHour),
          end_hour: this.formatHour(this.reservation.type === 'single' ? this.reservation.startHour : this.reservation.endHour),
        };

        if (this.isRecurring) {
          const startDate = new Date(this.selectedDay);
          let currentDate = new Date(startDate);
          let endDate;

          if (this.recurrenceEndMonth) {
            let [nyear, nmonth] = this.recurrenceEndMonth.split('-').map(Number);
            if (nmonth > 12) {
              nmonth = 1;
              nyear += 1;
            }
            endDate = new Date(nyear, nmonth, 0);
          } else {
            endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
          }

          const datesToCheck = [];
          while (currentDate <= endDate) {
            datesToCheck.push(this.formatDate(currentDate));
            currentDate.setDate(currentDate.getDate() + 7);
          }

          const conflictResponse = await axios.post('/reservations/conflicts', {
            room_id: this.selectedRoom.id,
            dates: datesToCheck,
            start_hour: payload.start_hour,
            end_hour: payload.end_hour,
          });

          const conflicts = conflictResponse.data.conflicts;

          if (conflicts.length > 0) {
            let conflictText = conflicts.map(c => {
              return `${c.username} 📅 ${c.date} ⏰ ${c.hours.join(', ')}`;
            }).join('\n');

            Toast.fire({
              icon: 'warning',
              title: 'Konflikt rezerwacji',
              html: `Na niektóre dni/godziny istnieją już rezerwacje:<br><br>${conflicts.map(c => `${c.usernames.join(', ')}: 📅 ${c.date} ⏰ ${c.hours.join(', ')}`).join('<br>')}`,
              timer: 5000,
              timerProgressBar: true,
              showConfirmButton: false,
            });
            const choice = await askConflictChoice(conflicts);

            if (choice === null || choice === '3') {
              Toast.fire({icon: 'info', title: 'Anulowano zapis rezerwacji.', timer: 1500});
              return;
            }

            if (choice === '2') {
              const conflictDates = conflicts.map(c => c.date);
              const filteredDates = datesToCheck.filter(d => !conflictDates.includes(d));

              if (filteredDates.length === 0) {
                Toast.fire({icon: 'info', title: 'Brak dni do zapisania', html: 'Wszystkie dni mają konflikty.'});
                return;
              }

              for (const dateStr of filteredDates) {
                const tempPayload = {...payload, date: dateStr};
                await this.saveSingleReservation(new Date(dateStr), tempPayload);
              }
            } else if (choice === '1') {
              for (const dateStr of datesToCheck) {
                const tempPayload = {...payload, date: dateStr};
                await this.saveSingleReservation(new Date(dateStr), tempPayload);
              }
            } else {
              Toast.fire({icon: 'error', title: 'Nieznany wybór, anulowano.'});
              return;
            }
          } else {
            for (const dateStr of datesToCheck) {
              const tempPayload = {...payload, date: dateStr};
              await this.saveSingleReservation(new Date(dateStr), tempPayload);
            }
          }
        } else {
          await this.saveSingleReservation(new Date(this.selectedDay), payload);
        }

        this.isModalOpen = false;
        Toast.fire({icon: 'success', title: 'Zapisano rezerwację!'});
        this.isRecurring = false;
        this.recurrenceEndMonth = null;
        this.monthOptions = this.getRemainingMonths();

      } catch (error) {
        Toast.fire({icon: 'error', title: 'Błąd zapisu rezerwacji.'});
        console.error('Błąd przy zapisie rezerwacji:', error);
        this.isRecurring = false;
        this.recurrenceEndMonth = null;
        this.monthOptions = this.getRemainingMonths();
      }
    },

async saveSingleReservation(date, payload) {
  try {
    const formattedDate = this.formatDate(date);
    payload.date = formattedDate;

    const response = await axios.post('/conferencerooms/reservation', payload);

    if (response.status !== 200) {
      throw new Error('Błąd przy zapisie rezerwacji');
    }

    const startHour = payload.start_hour;
    const endHour = payload.end_hour;

    const [startH, startM, startS] = startHour.split(':').map(Number);
    const [endH, endM, endS] = endHour.split(':').map(Number);

    let currentDate = new Date(2000, 0, 1, startH, startM, startS);
    const endDate = new Date(2000, 0, 1, endH, endM, endS);

    const isSingleReservation = currentDate.getTime() === endDate.getTime();

    while (
      currentDate < endDate ||
      (isSingleReservation && currentDate.getTime() === endDate.getTime())
    ) {
      const currentHour = currentDate.toTimeString().slice(0, 8);

      if (!this.localReservations[payload.room_id]) {
        this.$set(this.localReservations, payload.room_id, {});
      }

      if (!this.localReservations[payload.room_id][payload.date]) {
        this.$set(this.localReservations[payload.room_id], payload.date, {});
      }

      this.$set(
        this.localReservations[payload.room_id][payload.date],
        currentHour,
        { name: payload.username }
      );

      currentDate.setMinutes(currentDate.getMinutes() + 30);
    }

  } catch (error) {
    console.error('Błąd przy zapisaniu pojedynczej rezerwacji:', error);
  }
},



    async deleteReservation() {
      const payload = {
        room_id: this.selectedRoom.id,
        date: this.formatDate(this.selectedDay),
        start_hour: this.formatHour(this.reservation.startHour),
        end_hour: this.formatHour(this.reservation.endHour ?? this.reservation.startHour),
      };

      try {
        await axios.delete('/conferencerooms/reservation', {data: payload});

        const roomId = payload.room_id;
        const date = payload.date;
        const [startH, startM] = payload.start_hour.split(':').map(Number);
        const [endH, endM] = payload.end_hour.split(':').map(Number);

        let currentDate = new Date(2000, 0, 1, startH, startM);
        const endDate = new Date(2000, 0, 1, endH, endM);

        while (currentDate <= endDate) {
          const currentHour = currentDate.toTimeString().slice(0, 8);
          if (this.localReservations?.[roomId]?.[date]?.[currentHour]) {
            this.$delete(this.localReservations[roomId][date], currentHour);
          }
          currentDate.setMinutes(currentDate.getMinutes() + 30);
        }

        Toast.fire({icon: 'success', title: 'Rezerwacje usunięte.'});

      } catch (error) {
        Toast.fire({icon: 'error', title: 'Błąd przy usuwaniu rezerwacji.'});
      }
    }
    ,

    showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
  },
};
</script>


<style scoped>
.modal-backdrop {
  display: none;
}
.empty-slot {
  display: inline-block;
}
.rooms-container {
  gap: 1rem;
  white-space: nowrap;
  overflow-x: auto;
  padding-bottom: 0.5rem;
}

.room-card {
  flex: 0 0 270px;
  display: inline-block;
  position: relative;
}
table th, table td {
  padding: 0.2rem 0.3rem; 
}
.reservation-cell {
  position: relative;
}

.delete-btn {
  position: absolute;
  top: 0px;
  right: 0px;
  padding: 0.03rem 0.05rem;
  font-size: 0.9rem;
  z-index: 5;
  display: none;
}

.reservation-cell:hover .delete-btn {
  display: inline-block;
}

.selectKolor {
  border: 1px solid #d9d9d9; 
  background-color: #f8d7da;
  color: #000;
}
.btn-sm-oko {
  width: 32px; /* stała szerokość przycisku */
  height: 32px; /* stała wysokość przycisku */
  padding: 0; /* usuń padding żeby ikonka miała więcej miejsca */
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-sm-oko i {
  font-size: 20px; /* powiększ ikonę (Bootstrap Icons to fonty) */
  line-height: 1;
}
</style>